/*
 * Offers page (sections/main-offers.liquid).
 * - Works out each card's status again from the current time, because the
 *   cached page can be older than an offer's start or end time.
 * - Filter tabs by filter_tag. ?offer=<tag-handle> opens a tab on load.
 * - Copy code button.
 */
(function () {
  var DAY = 86400000;
  var WEEK = 7 * DAY;

  function statusOf(starts, ends, now) {
    if (starts && starts > now) {
      var d = Math.ceil((starts - now) / DAY);
      return { key: 'upcoming', label: d === 1 ? 'Starts tomorrow' : 'Starts in ' + d + ' days' };
    }
    if (ends && ends <= now) return { key: 'ended', label: 'Ended' };
    if (ends && ends - now <= WEEK) {
      var left = Math.ceil((ends - now) / DAY);
      return { key: 'ending', label: 'Ends in ' + left + ' day' + (left > 1 ? 's' : '') };
    }
    return { key: 'live', label: 'Live now' };
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {}
      document.body.removeChild(field);
      ok ? resolve() : reject();
    });
  }

  function initOffers(root) {
    if (root.dataset.offersReady) return;
    root.dataset.offersReady = 'true';

    var showEnded = root.dataset.showEnded === 'true';
    var showUpcoming = root.dataset.showUpcoming === 'true';
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-offer-filter]'));
    var empty = root.querySelector('[data-offers-empty]');
    var live = root.querySelector('[data-offers-live]');
    var now = Date.now();

    cards.forEach(function (card) {
      var st = statusOf(Number(card.dataset.starts) || 0, Number(card.dataset.ends) || 0, now);
      var badge = card.querySelector('[data-offer-status]');
      badge.className = 'offer-status offer-status--' + st.key;
      badge.querySelector('[data-offer-status-label]').textContent = st.label;

      var copy = card.querySelector('[data-offer-copy]');
      if (copy) {
        var usable = st.key === 'live' || st.key === 'ending';
        copy.disabled = !usable;
        if (!usable) copy.textContent = st.key === 'ended' ? root.dataset.endedLabel : root.dataset.notLiveLabel;
      }

      var excluded = (st.key === 'ended' && !showEnded) || (st.key === 'upcoming' && !showUpcoming);
      card.dataset.excluded = excluded ? 'true' : 'false';
    });

    var available = cards.filter(function (card) {
      return card.dataset.excluded !== 'true';
    });

    // Recount tabs and drop any left empty by the status pass above.
    chips.forEach(function (chip) {
      var tag = chip.dataset.offerFilter;
      var count = available.filter(function (card) {
        return tag === 'all' || card.dataset.tag === tag;
      }).length;
      chip.querySelector('[data-offer-count]').textContent = count;
      chip.hidden = tag !== 'all' && count === 0;
    });

    function select(tag) {
      var chip = chips.filter(function (c) {
        return c.dataset.offerFilter === tag && !c.hidden;
      })[0];
      if (!chip) tag = 'all';
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.dataset.offerFilter === tag ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        card.hidden = card.dataset.excluded === 'true' || (tag !== 'all' && card.dataset.tag !== tag);
      });
      if (empty) empty.hidden = available.length > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        select(chip.dataset.offerFilter);
      });
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-offer-copy]');
      if (!button || button.disabled) return;
      var code = button.dataset.code;
      var label = button.textContent;
      copyText(code).then(function () {
        button.textContent = root.dataset.copiedLabel;
        if (live) live.textContent = 'Code ' + code + ' copied';
        setTimeout(function () {
          button.textContent = label;
        }, 2000);
      }, function () {
        if (live) live.textContent = 'Could not copy. The code is ' + code;
      });
    });

    var initial = new URLSearchParams(window.location.search).get('offer');
    select(initial || 'all');
  }

  function initAll() {
    document.querySelectorAll('[data-offers]').forEach(initOffers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
